import React from "react";
import { Mic, Video, Volume2 } from "lucide-react";

const ICONS = { mic: Mic, cam: Video, speaker: Volume2 };
const LABELS = { mic: "Microphone", cam: "Camera", speaker: "Speaker" };

// Speaker selection needs setSinkId (Chrome/Edge/Firefox); Safari/iOS have no API for it.
export const speakerSelectionSupported = () =>
  typeof HTMLMediaElement !== "undefined" && typeof HTMLMediaElement.prototype.setSinkId === "function";

// One labelled <select>. `devices` = [{ deviceId, label }]; `value` = selected deviceId.
export function DeviceSelect({ kind, devices, value, onChange, disabled, dark = true }) {
  const Icon = ICONS[kind];
  if (!devices?.length) return null;
  return (
    <label className={`block text-left ${dark ? "text-white" : "text-slate-800"}`} data-testid={`device-select-${kind}`}>
      <span className={`text-[10px] uppercase tracking-wider font-bold inline-flex items-center gap-1 ${dark ? "text-white/60" : "text-slate-400"}`}>
        <Icon size={11} /> {LABELS[kind]}
      </span>
      <select
        value={value || ""}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
        data-testid={`device-select-${kind}-input`}
        className={`mt-1 w-full rounded-lg text-sm px-2.5 py-2 outline-none disabled:opacity-50 ${dark ? "bg-white/10 border border-white/15 text-white" : "bg-white border border-slate-200"}`}
      >
        {devices.map((d, i) => (
          <option key={d.deviceId || i} value={d.deviceId} className="text-slate-900">
            {d.label || `${LABELS[kind]} ${i + 1}`}
          </option>
        ))}
      </select>
    </label>
  );
}

// Group MediaDeviceInfo[] into { mics, cams, speakers }.
export function groupDevices(list) {
  const pick = (kind) => (list || []).filter((d) => d.kind === kind).map((d) => ({ deviceId: d.deviceId, label: d.label }));
  return { mics: pick("audioinput"), cams: pick("videoinput"), speakers: speakerSelectionSupported() ? pick("audiooutput") : [] };
}
